<script>
	import firebase from 'firebase/app';
	import { timestamp, db, storage, functions } from '../../../firebase';

	// Data and input handling
	import { user, createModal, activeTab, profileData } from '../../../store';
	import {push, pop} from 'svelte-spa-router'
	
	import {createForm} from 'svelte-forms-lib';
	import { text_area_resize } from '../../../helpers/autoResizeTextarea.js'

	// Modal animation and handling
	import {onMount, onDestroy} from 'svelte';
	import {fly,fade} from 'svelte/transition';
	import {quintOut} from 'svelte/easing';

	// Icons
	import Icon from '../../atoms/Icon.svelte';
	import cross from '../../../../public/assets/svg/24/cross.svg';
	import info from '../../../../public/assets/svg/14/info.svg';
	
	// Lock 
	import Lock from '../../atoms/Lock.svelte';

	// Dallee
	import DalleSelector from '../DalleSelector/DalleSelector.svelte';

	import * as bodyScrollLock from "body-scroll-lock";
	
	let modal;

	// const dispatch = createEventDispatcher();
	const close = () => {
		pop() || push('/');
		// dispatch('close');
		resetData();
	};
	const { form, errors, handleChange, handleSubmit } = createForm({
		initialValues: $createModal.initialInput,
		onSubmit: values => {
			// make form submission request with `values`
			saveIdea(isSecured);
		}
	});

	// Input counting
	let stepCounter = 1,
		maxTitle = 100,
		maxText = 300,
		showLicenseNote = false,
		showTerms = false,
		progressTime = 3000,
		textToImagePrompt = '';
	
	let uid = $user.uid,
		// author = $user.displayName, // idea author
		// authorImage = $user.picture, // idea author image
		fileInput, // actual file from input
		selectedImage, // image selected from DALLE or another API
		media = $createModal.initialInput.media || '', // media URL returned from Firebase after upload
		isHighlight = false, // initially set if it's a highlight or not.
		isPublic = true, // public is the default state of an idea
		isSecured = false, // draft is the default state of an idea
		saveCount = 0, // save default saveCount to database entry
		messageCount = 0; // save default messageCount to database entry

	$: titleLength = maxTitle - $form.title.length;
	$: textLength = maxText - $form.text.length;

	const saveIdea = (publicity) => {
		let	text = $form.text,
			title = $form.title;

		// if(publicity) {
		// 	let check = window.confirm('All set? Once published, you can\'t change your idea.');
		// 	if(!check)
		// 		return; // leave function without saving if confirm was not accepted.
		// }

		// show saving screen
		stepChanger(7);
		
		if(selectedImage) {	
			const storageRef = storage.ref('b64_uploads/'+uid+'_'+Date.now()+'.webp');

			storageRef.putString(selectedImage.b64Data, 'base64', {contentType: selectedImage.contentType}).then((snapshot) => {
				media = snapshot.metadata.fullPath;
				updateCollections(text, title, publicity);
				console.log('Uploaded a base64 string!');
			});

		} else {
			updateCollections(text, title, publicity)
			resetData();
		}
	}

	const resetData = () => {
		// reset form
		$form.title = '';
		$form.text = '';
		fileInput ? fileInput.value = '' : false;
		selectedImage = null;

		// reset initialInput in store
		$createModal.initialInput = {
			docId: null,
			title: '',
			text: '',
			media: '',
			absolutePath: ''
		};
	}

	const updateCollections = (text, title, publicity) => {
		if($createModal.initialInput.docId) {
			// publish already existing draft
			db.collection('ideas').doc($createModal.initialInput.docId).update({title, text, media, isPublic, isSecured: publicity, timestamp: timestamp})
			.then(() => closeModalAfterPublish(publicity))
			.catch((error) => console.log(error));
		}
		else {
			// add new idea to ideas collection
			db.collection('ideas').add({ uid, title, text, media, isPublic, isSecured: publicity, timestamp: timestamp, isHighlight, saveCount, messageCount })
			.then((docRef) => {
				// add newly created idea id to this users document
				db.collection('users').doc(uid).update({
					ideas: firebase.firestore.FieldValue.arrayUnion(docRef.id)
				}).catch((error) => console.log(error));
				// notify all users about this new idea
				notifyUsersAboutNewIdea(title, docRef.id)
				
			})
			.then(() => closeModalAfterPublish(publicity))
			.catch((error) => console.log(error));
		}
	}

	const templateData = (receiverName, ideaTitle, ideaId) => {
        return {
            receiver_name: receiverName, // email address to send to
            subject: ideaTitle ? ideaTitle.replace(/(.{35})..+/, "$1…") : '',
            idea_author: $profileData.name, // current user name that submitted this message
            idea_title: ideaTitle || '', // idea title
            idea_link: `https://app.originea.xyz/#/idea/${ideaId}` // deep link to idea
        }
    }

	
	const notifyUsersAboutNewIdea = async (ideaTitle, ideaId) => {
		let usersToNotify = [];
		db.collection('users').get()
		.then((snapshot => {
			snapshot.forEach(doc => {
				let data = doc.data();
				if(ideaTitle && ideaId && data.email, data.name) {
					usersToNotify = [...usersToNotify, {
						to: data.email,
						dynamic_template_data: templateData(data.name, ideaTitle, ideaId)
					}]
				}
			})
		}))
		.then(() => {
			// send notification to all users that have not unsubscribed to new idea notifications
			const sendEmail = functions.httpsCallable('sendEmail');
			sendEmail({
				type: 'idea',
				personalizations: usersToNotify
			})
			.then(result => {
				// Read result of the Cloud Function.
				console.log(result.data);
			}).catch(error => {
					console.log(error);
			});
		});
	}

	const closeModalAfterPublish = (publicity) => {
		// Close modal and go to right route
		setTimeout(()=> {
			if(publicity) {
				push('/newest')
				// curRoute.set('/');
				activeTab.set(2);
			}else {
				// Currently not visible in the app. This would be useful to open the drafts.
				// curRoute.set('/vault');
				push('/vault')
				activeTab.set(3);
			}
		},publicity ? progressTime : progressTime / 3)
	}

	const stepChanger = (step) => {
        window.scrollTo(0, 0);
        stepCounter = step;
	}
	
	const closeCheck = () => {
		if ($form.title) {
			let check = window.confirm('Changes will not be saved if you close now!');
			check ? close() : false;
		} else {
			close();
		}
	}

	onMount(() => {
		document.body.classList.add('modal-open');
		bodyScrollLock.disableBodyScroll(modal);
	});

	onDestroy(() => {
		document.body.classList.remove('modal-open');
		bodyScrollLock.enableBodyScroll(modal);
	});

</script>

<style lang="scss" src="./CreateModal.scss"></style>
<div class="create" bind:this={modal}>
	<div class="create__content" role="dialog" aria-modal="true"
		transition:fly="{{ y: window.innerHeight, duration: 500, easing: quintOut, opacity: 1}}">
		{#if stepCounter < 7}
			<div class="create__header">
				<div class="create__steps">
					<span>
						{stepCounter}/6
					</span>
				</div>
				<div class="create__close">
					<button on:click={closeCheck}>
						<Icon data={cross}></Icon>
					</button>
				</div>
			</div>
		{/if}
		<form class="create__form" on:submit={handleSubmit}>
			{#if stepCounter === 1}
				<p class="create__label">Add title</p>
				<textarea class="create__input" use:text_area_resize placeholder="Start with an interesting title to describe your idea." maxlength={maxTitle} bind:value={$form.title} on:change={handleChange}></textarea>
				<span class="create__info">
					<Icon data={info} size={'14px'} fill="#EDF22C" stroke="#341153" viewBox='0 0 14 14'></Icon>
					<small>{titleLength} characters left</small>
				</span>
				<div class="create__buttons btn__group">
					<button class="btn btn--primary is-light {$form.title.length ? '' : 'is-disabled'}" type="button" on:click={() => $form.title.length ? stepChanger(2) : false}>Next</button>
				</div>
			{:else if stepCounter === 2}
				<p class="create__label">Add text to image prompt</p>
				<textarea class="create__input" use:text_area_resize placeholder="Describe an image you can think of to visualize your idea." maxlength={maxText} bind:value={textToImagePrompt} on:change={handleChange}></textarea>
				<span class="create__info">
					<Icon data={info} size={'14px'} fill="#EDF22C" stroke="#341153" viewBox='0 0 14 14'></Icon>
					<small>Optional – Leave blank to generate an image based on your idea title instead.</small>
				</span>
				<div class="create__buttons btn__group">
					<button class="btn btn--primary is-light {$form.title.length ? '' : 'is-disabled'}" type="button" on:click={() => $form.title.length ? stepChanger(3) : false}>Next</button>
					<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => stepChanger(1)}>Back</button>
				</div>
			{:else if stepCounter === 3}
				<DalleSelector bind:selectedImage={selectedImage} bind:step={stepCounter} query={textToImagePrompt || $form.title}></DalleSelector>
			{:else if stepCounter === 4}
				<p class="create__label">Add description</p>
				<textarea class="create__input" use:text_area_resize placeholder="Add more details to describe your idea." maxlength={maxText} bind:value={$form.text} on:change={handleChange}></textarea>
				<span class="create__info">
					<Icon data={info} size={'14px'} fill="#EDF22C" stroke="#341153" viewBox='0 0 14 14'></Icon>
					<small>Optional – {textLength} characters left</small>
				</span>
				<div class="create__buttons btn__group">
					<button class="btn btn--primary is-light" type="button" on:click={() => stepChanger(5)}>Next</button>
					<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => stepChanger(3)}>Back</button>
				</div>
			{:else if stepCounter === 5}
				<p class="create__label">Agree to license</p>
				<p class="create__note">This idea will be under</p>
				<h2 class="create__license__title">Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License.</h2>
				<button class="create__readmore" type="button" on:click={() => {showLicenseNote = ! showLicenseNote}}>{showLicenseNote ? 'Read less' : 'Read more'}</button>
				{#if showLicenseNote}
					<div class="create__license__note">
						<p>Others are free to share and adapt your idea under the following terms.</p>
						<p>Attribution — They must give appropriate credit and indicate if changes were made.</p>
						<p>NonCommercial — They may not use the material for commercial purposes.</p>
						<p>ShareAlike — If they remix, transform, or build upon the material, they must distribute your contributions under the same license as the original.</p>
						<p>
							<a class="create__link" href="https://creativecommons.org/faq/" target='_blank'>Learn more about Creative Commons</a>
						</p>
					</div>
				{/if}
				<div class="create__buttons btn__group">
					<button class="btn btn--primary is-light" type="button" on:click={() => stepChanger(6)}>Agree</button>
					<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => stepChanger(4)}>Back</button>
				</div>
			{:else if stepCounter === 6}
				<h1 class="create__pubish__title">Ready to publish your idea to the community?</h1>
				<p class="create__note">
					By publishing, you agree to our <button class="create__readmore" type="button" on:click={() => {showTerms = ! showTerms}}>{showTerms ? 'terms.' : 'terms.'}</button>
				</p>
				{#if showTerms}
					<div class="create__publish__note">
						<p>Publishing means permanently saving an idea and making it publicly visible to the entire Originea community. Published ideas are immutable and can no longer be changed.</p>
						<p>By publishing, you confirm that you own the intellectual property of this idea’s title, text and uploaded imagery.</p>
						<p>You acknowledge that you will not publish any offensive, racist or sexually suggestive ideas.</p>
						<p>Originea cannot be prosecuted for any missue and reserves the right to delete or change ideas in case of doubt.</p>
					</div>
				{/if}
				<div class="create__submit btn__group">
					<button class="btn btn--primary is-light secure" type="submit" on:click={() => {isSecured = true }}>Publish</button>
					<!-- <button class="btn btn--secondary is-dark is-outline draft" type="submit" on:click={() => {isSecured = false }}>Save draft</button> -->
					<!-- <button class="btn btn--tertiary" type="button" on:click={() => stepChanger(4)}>Back</button> -->
					<button class="btn btn--secondary is-dark is-outline" type="button" on:click={() => stepChanger(5)}>Back</button>
				</div>
			{/if}
		</form>
		{#if stepCounter === 7}
			{#if isSecured}
				<Lock time={progressTime} draft={false}></Lock>
			{:else}
				<Lock time={progressTime / 3} draft={true}></Lock>
			{/if}
		{/if}
	</div>
	<div class="create__background" on:click={close} transition:fade="{{ duration: 500 }}"></div>
</div>